import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../Components/SidBarButtons/Button'
import { observer } from 'mobx-react-lite'
import { auth } from './../store/auth'
import { appName } from '../Service/http'
export default observer(function AdminSideBar() {
	const { t } = useTranslation()

	const style = {
		show: {
			left: 0
		},
		hide: {
			left: '-100%'
		}
	}

	return (
		<div className='SideBar_container' style={auth.menuShow ? style.show : style.hide}>
			<div className='SideBarButtonsWrapper'>
				<Button route={`${appName}/students`} text={t('sideBar.students')}>
					<i className='fas fa-user-graduate'></i>
				</Button>
				<Button route={`${appName}/teachers`} text={t('sideBar.teachers')}>
					<i className='fas fa-user-tie'></i>
				</Button>
				{auth.user.data.AVN20 === 0 && auth.user.data.AVN_BT_report === 1 ? (
					<>
						<Button route={`${appName}/applications`} text={t('sideBar.applications')}>
							<i className='fas fa-tasks'></i>
						</Button>

						<Button route={`${appName}/applicationsTeacher`} text={t('sideBar.applicationsTeacher')}>
							<i class="fa-solid fa-chalkboard-user"></i>
						</Button>
						{/* <Button
              route={`${appName}/registration`}
              text={t("sideBar.doc_registration")}
            >
              <i className="fas fa-scroll"></i>
            </Button> */}
					</>
				) : null}
				{auth.user.data.AVN20 === 1 && auth.user.data.AVN_BT_report === 1 ? (
					<>
						<Button route={`${appName}/applications`} text={t('sideBar.applications')}>
							<i className='fas fa-tasks'></i>
						</Button>

						<Button route={`${appName}/applicationsTeacher`} text={t('sideBar.applicationsTeacher')}>
							<i class="fa-solid fa-chalkboard-user"></i>
						</Button>
						{/* <Button
              route={`${appName}/registration`}
              text={t("sideBar.doc_registration")}
            >
              <i className="fas fa-scroll"></i>
            </Button> */}
						<Button route={`${appName}/directory`} text={t('sideBar.redact')}>
							<i className='fas fa-cogs'></i>
						</Button>
						<Button route={`${appName}/accepter`} text={t('sideBar.permissions')}>
							<i className='fas fa-key'></i>
						</Button>
						{/* <Button route={`${appName}/check_eds`} text='ППД'>
							<i className='fas fa-key'></i>
						</Button> */}

						{/* <a className='a_button' href={'/eds'} target='_blank'>
							<i className='fa-solid fa-sheet-plastic'></i>
							<p>{t('sideBar.signingEsp')}</p>
						</a> */}
					</>
				) : null}

				{auth.user.data.AVN20 === 1 && auth.user.data.AVN_BT_report === 0 ? (
					<>
						<Button route={`${appName}/applications`} text={t('sideBar.applications')}>
							<i className='fas fa-tasks'></i>
						</Button>

						<Button route={`${appName}/applicationsTeacher`} text={t('sideBar.applicationsTeacher')}>
							<i class="fa-solid fa-chalkboard-user"></i>
						</Button>
						{/* <Button
              route={`${appName}/registration`}
              text={t("sideBar.doc_registration")}
            >
              <i className="fas fa-scroll"></i>
            </Button> */}
						<Button route={`${appName}/directory`} text={t('sideBar.redact')}>
							<i className='fas fa-cogs'></i>
						</Button>

						<Button route={`${appName}/accepter`} text={t('sideBar.permissions')}>
							<i className='fas fa-key'></i>
						</Button>
						{/* <Button route={`${appName}/check_eds`} text='ППД'>
							<i className='fas fa-key'></i>
						</Button> */}

						{/* <a className='a_button' href='/eds'>
							<i className='fa-solid fa-sheet-plastic'></i>
							{t('sideBar.signingEsp')}
						</a> */}
					</>
				) : null}

				{auth.user.data.RUTOKEN === 1 && auth.user.data.AVN_BT_report === 1 ? (
					<>
						{/* <Button route={`${appName}/applications`} text={t('sideBar.applications')}>
							<i className='fas fa-tasks'></i>
						</Button> */}
						{/* <Button
              route={`${appName}/registration`}
              text={t("sideBar.doc_registration")}
            >
              <i className="fas fa-scroll"></i>
            </Button> */}
						{/* <Button route={`${appName}/directory`} text={t('sideBar.redact')}>
							<i className='fas fa-cogs'></i>
						</Button>
						<Button route={`${appName}/accepter`} text={t('sideBar.permissions')}>
							<i className='fas fa-key'></i>
						</Button> */}
						{/* <Button route={`${appName}/check_eds`} text='ППД'>
							<i className='fas fa-key'></i>
						</Button> */}
						<a className='a_button' href={'/eds'} target='_blank'>
							<i className='fa-solid fa-sheet-plastic'></i>
							<p>{t('sideBar.signingEsp')}</p>
						</a>
					</>
				) : null}

				{auth.user.data.RUTOKEN === 1 && auth.user.data.AVN_BT_report === 0 ? (
					<>
						{/* <Button route={`${appName}/applications`} text={t('sideBar.applications')}>
							<i className='fas fa-tasks'></i>
						</Button> */}
						{/* <Button
              route={`${appName}/registration`}
              text={t("sideBar.doc_registration")}
            >
              <i className="fas fa-scroll"></i>
            </Button> */}
						{/* <Button route={`${appName}/directory`} text={t('sideBar.redact')}>
							<i className='fas fa-cogs'></i>
						</Button> */}

						{/* <Button route={`${appName}/accepter`} text={t('sideBar.permissions')}>
							<i className='fas fa-key'></i>
						</Button> */}
						{/* <Button route={`${appName}/check_eds`} text='ППД'>
							<i className='fas fa-key'></i>
						</Button> */}
						<a className='a_button' href='/eds'>
							<i className='fa-solid fa-sheet-plastic'></i>
							{t('sideBar.signingEsp')}
						</a>
					</>
				) : null}

				<Button route={`${appName}/reports`} text={t('sideBar.reports')}>
					<i class='fa-solid fa-clipboard-list'></i>
				</Button>
			</div>
			<a href='https://www.youtube.com/watch?v=FtwYaaIsFT4' target='_blank' rel='noreferrer' className='Rukovodstvo'>
				{' '}
				<i className='fab fa-youtube'></i>
				{t('st:other.userDocs')}
			</a>
			<div className='ProgramVersions'> 
				<p>© 2023 App from AVN. v4.0.0</p>
			</div>
		</div>
	)
})
